const ns = "MODULES_RECORDS_FILTERS";
export const BULK_SET_SELECTED_ROWS = `${ns}_BULK_SET_SELECTED_ROWS`;
export const CLEAR_SEARCH = `${ns}CLEAR_SEARCH`;
export const DESELECT_ALL_ROWS = `${ns}_DESELECT_ALL_ROWS`;
export const SEARCH = `${ns}_SEARCH`;
export const TABLE_LAYOUT_OPTIONS = `${ns}_TABLE_LAYOUT_OPTIONS`;
export const TABLE_LAYOUT_STYLE = `${ns}_TABLE_LAYOUT_STYLE`;
export const TYPE = `${ns}_TYPE`;
export const VIEW = `${ns}_VIEW`;
